import { render } from "./TransferFormContainer.vue?vue&type=template&id=0a7b7f6e"
import script from "./TransferFormContainer.vue?vue&type=script&lang=js"
export * from "./TransferFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__